import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "D:\\laragon\\www\\surilipat-hub\\frontend\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\laragon\\www\\surilipat-hub\\frontend\\src\\app\\homepage\\components\\Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\laragon\\www\\surilipat-hub\\frontend\\src\\app\\service-information\\components\\FabricCareGuide.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\laragon\\www\\surilipat-hub\\frontend\\src\\app\\service-information\\components\\PricingCalculator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\laragon\\www\\surilipat-hub\\frontend\\src\\app\\service-information\\components\\SeasonalTips.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\laragon\\www\\surilipat-hub\\frontend\\src\\components\\common\\Header.tsx");
;
import(/* webpackMode: "eager" */ "D:\\laragon\\www\\surilipat-hub\\frontend\\src\\components\\ui\\AppIcon.tsx");
